// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".starRating{display:flex;flex-wrap:wrap}", "",{"version":3,"sources":["webpack://./StarRating/StarRating.scss"],"names":[],"mappings":"AAAA,YACE,YAAA,CACA,cAAA","sourcesContent":[".starRating {\n  display: flex;\n  flex-wrap: wrap;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
